/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import hex from 'crypto-js/enc-hex';
import sha1 from 'crypto-js/sha1';
import GizmoSDK from '../../lib/gizmo-sdk.js';
import Loading from '../Loading';
// import RotateNav from '../RotateNav';
import Controller from '../Controller';
import Wait from '../Wait';
import { getParameterByName } from '../../utils/';
import './index.scss';

const UID = !!getParameterByName('uid') ?
  getParameterByName('uid') : '6af73a74cbe1d1143f893828510c01c8b0b5b3ba';
const iframeSrc = `https://gizmohub.com/demos/vv7-embed-2/?uid=${UID}&model.gmc=1&ts=256&mps=0&${Date.now()}`;

let gh;
export default function Viewer(props) {
  const onProgressList = [];
  const iframeEl = useRef(null);
  const [ start, setStart ] = useState(false);
  const [ loaded, setLoaded ] = useState(true);
  const [ annotationDialog, setAnotationDialog ] = useState(false);
  const [ progress, setProgress ] = useState(0);
  const [ carState, setCarState ] = useState({});
  const [ carOptions, setCaroptions ] = useState({});
  const [ speedData1, setSpeedData1 ] = useState({
    time: 0.0,
    distance: 0,
    speed: 0
  });
  const [ speedData2, setSpeedData2 ] = useState({
    time: 0.0,
    distance: 0,
    speed: 0
  });

  useEffect(() => {
    initSDK(iframeEl.current)
    return () => {
      gh.off('gizmohub:start');
      gh.off('gizmohub:preload:progress');
    }
    console.log(progress)
  }, [])

  return (
    <div className="viewer-root">
      <iframe
        title="application"
        ref={iframeEl}
        id="application"
        className="case-show"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        allowFullScreen="allowfullscreen"
        frameBorder="0"
        src={iframeSrc}
        scrolling="no"
        width="100%"
        height="100%"
      />
      {/*<div style={{ visibility: 'hidden' }}>*/}
        {!start &&
        <Loading
          progress={progress}
        />}
        {start &&
        <Controller
          style={{display: !annotationDialog ? 'block' : 'none'}}
          carState={carState}
          carOptions={carOptions}
          onChange={onChange}
          loaded={loaded}
          speedData={{
            car1: speedData1,
            car2: speedData2
          }}
          gh={gh}
        />}
      {/*</div>*/}
      {!loaded && <Wait />}
    </div>
  )

  function initSDK(frameDom) {
    gh = window.gh = new GizmoSDK(frameDom, { targetOrigin: '*' });
    gh.on('gizmohub:start', () => {
      gh.getState((data) => {
        console.log('state: ', data);
        setCarState(data);
      });
      gh.getOptions((data) => {
        console.log('options: ', data);
        setCaroptions(data);
        setStart(true);
      });
    });

    gh.on('gizmohub:preload:progress', (progress) => {
      console.log('progress:', progress);
      setProgress(progress * 100);
    });

    gh.on('gizmohub:postInitialize', () => {
      console.log('postInitialize success');
    });

    gh.on('gizmohub:annotation:dialog', (bool) => {
      setAnotationDialog(bool);
    });

    gh.on(`gizmohub:model:${UID}:speeder:speed+distance`, (data) => {
      // console.log('car1:', data.time, data.speed);
      setSpeedData1(data);
    });

    gh.on('gizmohub:ar:model:inside', (num) => {
      // arInside = !!num;
    });
  }

  function onChange(filed, value) {
    console.log(filed, value, 'change controller');
    switch (filed) {
      case 'differ':
        setDiffer(value);
        break;
      case 'scene':
        onSkyboxProgress(value.uid);
        // setTimeout(() => {
        //   gh.setState({[filed]: value});
        // }, 100);
      case 'wheel':
        onModelProgress(value.uid);
      case 'view':
        // entryAr = value.enabled;
      default:
        gh.setState({[filed]: value});
        break;
    }
  }

  function setDiffer(value) {
    gh.getState((state) => {
      if (value.target) {
        onModelProgress(value.target);
      }
      const differ = {...state.differ, ...value, ...{ distance: 2.8 }, ...genSign()};
      gh.setState({ differ });
    });
  }

  function genSign() {
    // const accesskey = 'waeFhcKlTq';
    // const secretkey = 'ef2fe2a4023596cea7d46e16356008a0e6b7f16c';

    // production: youcheyihou
    // const accesskey = 'KTxCe4KGCc';
    // const secretkey = 'tgxhxjwyhehzbtnfgtatt9jfydlvhcpjnxuymcbd';

    // production: youcheyihou
    const accesskey = 'wszLtLvuJ6';
    const secretkey = 'cd94c2f86fff6b728871db9b4d4ed2b3225d6ff5';

    const timestamp = Date.now() / 1000 | 0;
    const signature = btoa( sha1(accesskey + secretkey + timestamp).toString(hex) );

    return { accesskey, timestamp, signature };
  }

  function onModelProgress(uid) {
    if (hasOnprogrees(uid)) {
      return;
    }

    gh.on('gizmohub:model:' + uid + ':progress', (data) => {
      setLoaded(data === 1);
      if (data === 1) {
        gh.getState((state) => {
          console.log('state: ', state);
          gh.setState({skybox: state.skybox});
        });
      }
    });

    gh.on(`gizmohub:model:${uid}:speeder:speed+distance`, (data) => {
      // console.log('car2', data.time, data.speed);
      setSpeedData2(data);
    });
  }

  function genSignUrl() {
    const { accesskey, timestamp, signature } = genSign();
    return `accesskey=${accesskey}&timestamp=${timestamp}&signature=${signature}`;
  }

  function hasOnprogrees(uid) {
    if (onProgressList.find((oUid) => oUid === uid)) {
      return true;
    }
    onProgressList.push(uid);
    return false;
  }

  function onSkyboxProgress(uid) {
    if (hasOnprogrees(uid)) {
      return;
    }

    gh.on('gizmohub:scene:' + uid + ':progress', (data) => {
        console.log('skybox loading', data);
        setLoaded(data === 1);
    });
  }
}

